import React from "react";

// Clean full-width image displayed just above the footer on every page.
export const PreFooterBanner = () => {
  return (
    <section
      className="relative w-full overflow-hidden bg-white pt-6 sm:pt-10 pb-10 sm:pb-16 lg:pb-20"
      data-testid="pre-footer-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl overflow-hidden shadow-md">
          <img
            src="/images/banner-prefooter-1200.webp"
            srcSet="/images/banner-prefooter-800.webp 800w, /images/banner-prefooter-1200.webp 1200w, /images/banner-prefooter-1600.webp 1600w, /images/banner-prefooter-1920.webp 1920w"
            sizes="(min-width: 1280px) 1216px, 100vw"
            alt="Fresh View reinigt dak, zonnepanelen, gevel en ramen in heel Vlaams-Brabant"
            width="1600"
            height="1066"
            loading="lazy"
            decoding="async"
            className="w-full h-auto block"
          />
        </div>
      </div>
    </section>
  );
};

export default PreFooterBanner;
